import { createStyles } from 'antd-style'

export const useStyles = createStyles((_, props: { isActive?: boolean }) => ({
  expandIcon: {
    svg: {
      fontSize: 14
    }
  },
  collapseArrow: {
    svg: {
      fontSize: 24,
      transform: `rotate(${props.isActive ? 0 : 180}deg)`
    }
  }
}))
